import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl, Validators, FormArray } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { ToasterService } from 'angular2-toaster';
import { Observable, Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { catchError, map, switchMap } from 'rxjs/operators';
import { combineLatest } from 'rxjs/observable/combineLatest';

import { AuthService } from '../../../../services/auth.service';
import { LoadingSpinnerService } from '../../../../services/loading-spinner.service';
import { PdfService } from '../../../../services/pdf.service';
import { ProjectManagerService } from '../../../../services/project-manager.service';
import { AddonManagerService } from '../../../../services/addon-manager.service';
import { ProjectSaveService } from '../../../../services/project-save.service';
import { ModalSaveComponent } from '../../modal-save/modal-save.component';
import { GetQuoteResourceService } from '../services/get-quote-resource.service';
import { GetQuoteInfoService } from '../services/get-quote-info.service';
import { zipCodeNotEmpty } from './form-validators/zip-code-not-empty';
import { environment } from '../../../../../environments/environment';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { DataForDisplayingMenuItemsService } from '../../../../services/data-for-displaying-menu-items.service';
import { RailingGenerationService } from '../../../../services/railing/services/railing-generation.service';
import { InfillsService } from '../../../../services/railing/infills/infills.service';
import * as CANADA_STATES from 'assets/countries/canada';
import * as US_STATES from 'assets/countries/us';
import { TopToolbarService } from '../../../../services/topToolbar.service';
import { RendererService } from '../../../../services/renderer.service';
import { StageService } from '../../../../services/stage.service';
import { Select3dService } from '../../../../services/select-3d.service';
import { SnapShotService } from '../../../../services/snap-shot.service';
import { FloorHull } from '../../../../custom/FloorHull';
import { ConstantsService } from '../../../../services/constants.service';
import { AutoScaleSprite } from '../../../../custom/AutoScaleSprite';
import { SizeHelperService } from '../../../../services/size-helper.service';
import { RailingCalculationHelperService } from '../../../../services/railing/services/railing-calculation-helper.service';
import { ProductsService } from '../../../../services/products.service';
import { DragFloorEdge } from '../../../../services/drag-floor-edge.service';
import { SceneUtilsService } from '../../../../services/scene-utils.service';
import { ImageUtilsService } from '../../../../services/image-utils.service';
import { ZoomService } from '../../../../services/zoom.service';
import { CameraService } from '../../../../services/camera.service';
import {phoneNumberNotEmpty} from "./form-validators/phone-number-not-empty";
import { modernSpanInches } from '../../../../models/2d3d/modern.config';

declare let THREE: any;

@Component({
  selector: 'app-modal-get-quote-info',
  templateUrl: './modal-get-quote-info.component.html',
  styleUrls: ['./modal-get-quote-info.component.scss']
})
export class ModalGetQuoteInfoComponent implements OnInit {
  private _loader = new THREE.TextureLoader();
  form: FormGroup;
  projectName: string;
  isSaved: boolean;
  isAuthorization = true;
  saveAsNewProject = false;
  saveInProgress = false;
  admin = false;
  initSubscription: Subscription;
  currentStep = 1;
  currentTitle = 'Enter Your Details';
  coords: any;
  dealersData: any;
  dealer: any;
  isGetDealerData = true;
  isDisabledThirdStepButton = true;
  isDisabledSecondStepButton = true;
  isDisabledFirstStepButton = true;
  showLoading = false;
  showTypeOutdoorLocation = false;
  showDistanceFromWaterLocation = false;
  showCustomAngle = false;
  showCustomFasciaHeight = false;
  showCustomFasciaThickness = false;
  states: any = US_STATES.default.states;
  isInterior = false;
  screenShot = '';
  accessories = [];
  isShowIntermediateRail = false;
  infillType = '';
  infillForOperation = '';
  isStairsInScene = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ModalSaveComponent>,
    // private auth: AuthService,
    private projectManagerService: ProjectManagerService,
    private addonManagerService: AddonManagerService,
    private toasterService: ToasterService,
    private location: Location,
    private loadingSpinnerService: LoadingSpinnerService,
    private projectSaveService: ProjectSaveService,
    private fb: FormBuilder,
    private authService: AuthService,
    private getQuoteResourceService: GetQuoteResourceService,
    private getQuoteInfoService: GetQuoteInfoService,
    private dataMenuItems: DataForDisplayingMenuItemsService,
    private pdfService: PdfService,
    private topToolbarService: TopToolbarService,
    private rendererService: RendererService,
    private stageService: StageService,
    private select3dService: Select3dService,
    private snapShotSrvc: SnapShotService,
    private constants: ConstantsService,
    private railingGenerationService: RailingGenerationService,
    private sizeHelper: SizeHelperService,
    private railingCalculationHelperService: RailingCalculationHelperService,
    private productSrvc: ProductsService,
    private dragFloorEdgeService: DragFloorEdge,
    private sceneUtils: SceneUtilsService,
    private imageUtilsService: ImageUtilsService,
    private zoomSrvc: ZoomService,
    private cameraService: CameraService,
  ) {
    this.loadingSpinnerService.loaderActive.subscribe(value => {
      this.saveInProgress = value;
    });
    if (this.data && this.data.projectType === 'interior') {
      this.isInterior = true;
    }
  }

  private _checkForStairs() {
    this.stageService.getScene().traverse(el => {
      if (el.name.includes('stair')) {
        this.isStairsInScene = true;
      }
    });
  }

  private _createForm() {
    let project;
    let currentChoices;
    let currentProject;
    if (this.isInterior) {
      project = this.addonManagerService.addonProject;
      const railing = project.railing;
      currentChoices = {
        cornerPosts: railing.cornerPosts,
        infill: railing.infill,
        lighting: {},
        postMounting: railing.postMounting,
        railingColors: [],
        railingHeight: railing.railingHeight,
        railingHeightForStairs: '',
        railingType: railing.railingType[0],
        stairHandrail: '',
        topRail: railing.topRail,
        topRailForStairs: '',
        verticalPicketColorName: railing.verticalPicketColorName,
        verticalPicketShapeType: railing.verticalPicketShapeType,
      };
    } else {
      project = this.projectManagerService.project;
      currentChoices = this.dataMenuItems.getCurrentParams();
      currentProject = this.projectManagerService.getCurrentProject();
      console.log('project', project);
    }
    this.accessories = project.accessories;
    // console.log('project', project);
    // console.log('currentProject', currentProject);
    // console.log('currentChoices', currentChoices);
    this.isShowIntermediateRail = !!currentChoices.infillIntermediateRail;
    this.infillType = this.getQuoteInfoService.getInfillTypeValue(currentChoices.infill);
    let colors = this.dataMenuItems.getRailingCurrentColor(currentChoices.railingType);
    // console.log('colors', colors);
    let topRailColor, topCapColor, postColor, picketColor, laserColor;
    for (let color in colors) {
      switch (color) {
        case 'Post':
          if (colors[color].selected.name) {
            postColor = colors[color].selected.name;
          }
          break;
        case 'Top Rail':
          if (colors[color].selected.name) {
            topRailColor = colors[color].selected.name;
          }
          break;
        case 'Top Cap':
          if (colors[color].selected.name) {
            topCapColor = colors[color].selected.name;
          }
          break;
        case 'Picket':
          if (colors[color].selected.name) {
            picketColor = colors[color].selected.name;
          }
          break;
        // case this.getQuoteInfoService.updateInfillValue(currentChoices.infill):
        //   if (colors[color].selected.name) {
        //     laserColor = colors[color].selected.name;
        //   }
        //   break;
      }
      if (color.includes('Laser')) {
        if (colors[color].selected.name) {
          laserColor = colors[color].selected.name;
        }
      }
    }
    // console.log('colors', colors);
    const user = this.authService.getUser();
    // console.log('user', user);
    // console.log('this.data', this.data);
    // console.log('topCapColor', topCapColor);
    this.form = this.fb.group({
      firstName: [user.firstName || ''],
      lastName: [user.lastName || ''],
      company: [user.companyName || ''],
      phone: [user.phone || '', [phoneNumberNotEmpty()]],
      email: [user.email || ''],
      zipCode: [user.zipCode || '', [zipCodeNotEmpty()]],
      projectName: [project.projectName],
      comments: [''],
      agreed: [true],
      dealers: this.fb.array([]),
      selected: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      stateProvince: '',
      projectZip: '',
      country: 'US',
      buyingTimeFrame: 'Less than 1 month',
      projectType: '',
      projectLocation: '',
      projectTypeOutdoorLocation: '',
      projectDistanceFromWaterLocation: 0,
      railingHeight: currentChoices.railingHeight === '38' ? '39' : currentChoices.railingHeight, // There is hard task to change railingHeight from 38 to 39 in project
      infill: this.getQuoteInfoService.updateInfillValue(currentChoices.infill, currentChoices.railingType),
      infillColor: laserColor || '',
      mountingOption: currentChoices.postMounting,
      mountingSurface: !this.isInterior ? this.getQuoteInfoService.getDeckMatereal(currentProject.deckMaterial) : '',
      topRail: this.getQuoteInfoService.updateTopRailValue(currentChoices.topRail, currentChoices.topRailForStairs , topCapColor),
      postColor: postColor,
      topRailColor: topRailColor,
      intermediatePicket: currentChoices.infillIntermediateRail ? picketColor : 'None',
      laserPanelColor:
        (currentChoices.infill || '').indexOf('laserCut') === 0 ? laserColor : 'None',
      fasciaThickness: '',
      fasciaHeight: '',
      stairPostAngle: '',
      customFasciaHeight: '',
      customFasciaThickness: '',
      customAngle: '',
      stairHandrail: this.getQuoteInfoService.updateHandRailValue(currentChoices.stairHandrail),
      lighting: currentChoices.lighting,
      basePlateCovers: currentChoices.basePlateCovers,
      infillIntermediateRail: currentChoices.infillIntermediateRail || false,
      infillConcealKits: currentChoices.infillConcealKits || false,
      infillStandartCablerailKits: currentChoices.infillStandartCablerailKits || false,
      infillStSteelEndCaps: currentChoices.infillStSteelEndCaps || false,
      infillStSteelPickets: currentChoices.infillStSteelPickets || false,
      // accessories: currentProject.accessories
    });
  }

  private _formatZipCode(zipCode: string) {
    const removeSpacesRegexp = new RegExp(/\s/g);
    const middleSpaceRegexp = new RegExp(/^(.{3})(.{3})$/gi);
    return zipCode.replace(removeSpacesRegexp, '').replace(middleSpaceRegexp, '$1 $2');
  }

  private _getCurrentPosition() {
    return Observable.create(observer => {
      navigator.geolocation.getCurrentPosition(
        ({ coords }) => {
          // console.log('coords', coords);
          // observer.next({ latitude: 43.4551, longitude: -80.160055 });
          this.coords = { latitude: coords.latitude, longitude: coords.longitude };
          observer.next({ latitude: coords.latitude, longitude: coords.longitude });
        },
        err => {
          observer.next(null);
        }
      );
    });
  }

  hideShowFasciaHeightThicknessSelection () {
    if (
      (this.form.get('mountingOption').value === 'Fascia Mount'
      || this.form.get('mountingOption').value === 'Fascia Bracket Mount'
      )
      // && (this.dataMenuItems.getCurrentParams().infill === 'horizontalCableBaserail'
      // || this.dataMenuItems.getCurrentParams().infill === 'horizontalCable')
      // // && this.dataMenuItems.getCurrentParams().railingType === 'DesignRail'
    ) {
      return true;
    } else {
      return false;
    }
  }

  async nextStep() {
    // console.log('dataMenuItems', this.dataMenuItems.getCurrentParams());
    // console.log('railingGeneration', this.railingGeneration);
    // console.log('infillsService', this.infillsService);
    if (this.currentStep < 4) {
      this.currentStep = this.currentStep + 1;
    }
    if (this.currentStep === 3 ) {
      await this.onSubmitWithGetDealers();
    }
    this.setTitleValue();
  }

  prevStep() {
    if (this.currentStep > 1) {
      this.currentStep = this.currentStep - 1;
    }
    this.setTitleValue();
  }

  setTitleValue() {
    switch (this.currentStep) {
      case 1: this.currentTitle = 'Enter Your Details';
        break;
      case 2: this.currentTitle = 'Enter Project Details';
        break;
      case 3: this.currentTitle = 'Verify and Complete Your Selections';
        break;
      case 4: this.currentTitle = 'Select from Your nearest Dealer (choose one)';
        break;
    }
  }

  activateNextButtonByFillRequireFormFields(isCountryField: boolean = false) {
    if (isCountryField) {
      this.selectCountryStates();
    }
    switch (this.currentStep) {
      case 1:
        if (
          this.form.get('firstName').value &&
          this.form.get('lastName').value &&
          this.form.get('email').value &&
          this.form.get('phone').value &&
          this.form.get('zipCode').value &&
          this.form.get('projectName').value &&
          this.form.get('agreed').value
        ) {
          this.isDisabledFirstStepButton = false;
        } else if (!this.isDisabledFirstStepButton) {
          this.isDisabledFirstStepButton = true;
        }
        break;
      case 2:
        if (
          this.form.get('addressLine1').value &&
          this.form.get('projectZip').value &&
          this.form.get('buyingTimeFrame').value &&
          this.form.get('country').value
        ) {
          this.isDisabledSecondStepButton = false;
        } else if (!this.isDisabledSecondStepButton) {
          this.isDisabledSecondStepButton = true;
        }
        break;
      case 3:
        let filterKeys = ['projectType', 'projectLocation', 'fasciaHeight', 'fasciaThickness', 'stairPostAngle'];
        if (!this.form.get('mountingOption').value.includes('Fascia')) {
          filterKeys = filterKeys.filter(el => el !== 'fasciaHeight' && el !== 'fasciaThickness');
        }
        if (!this.isStairsInScene) {
          filterKeys = filterKeys.filter(el => el !== 'stairPostAngle');
        }
        const getItemsInBooleanFromForm = filterKeys.map(key => this.form.get(key).value);
        if (getItemsInBooleanFromForm.filter(bool => bool).length === getItemsInBooleanFromForm.length && !this.isGetDealerData) {
          this.isDisabledThirdStepButton = false;
        } else if (!this.isDisabledThirdStepButton) {
          this.isDisabledThirdStepButton = true;
        }
        // if (this.form.get('mountingOption').value.includes('Fascia')) {
        //   if (
        //     this.form.get('projectType').value &&
        //     this.form.get('projectLocation').value &&
        //     this.form.get('fasciaHeight').value &&
        //     this.form.get('fasciaThickness').value &&
        //     this.form.get('stairPostAngle').value
        //   ) {
        //     this.isDisabledThirdStepButton = false;
        //   } else if (!this.isDisabledThirdStepButton) {
        //     this.isDisabledThirdStepButton = true;
        //   }
        // } else {
        //   if (
        //     this.form.get('projectType').value &&
        //     this.form.get('projectLocation').value &&
        //     this.form.get('stairPostAngle').value
        //   ) {
        //     this.isDisabledThirdStepButton = false;
        //   } else if (!this.isDisabledThirdStepButton) {
        //     this.isDisabledThirdStepButton = true;
        //   }
        // }
        break;
    }
  }

  selectCountryStates() {
    switch (this.form.get('country').value) {
      case 'US': {
        this.states = US_STATES.default.states;
        break;
      }
      case 'Canada': {
        this.states = CANADA_STATES.default.states;
        break;
      }
    }
    this.form.get('stateProvince').setValue(this.states[0]);
  }

  selectStairPostAngle() {
    switch (this.form.get('stairPostAngle').value) {
      case 'Custom angle': {
        this.showCustomAngle = true;
        break;
      }
      default: {
        this.showCustomAngle = false;
        this.form.get('customAngle').setValue('');
      }
    }
    this.activateNextButtonByFillRequireFormFields();
  }

  selectFasciaHeight() {
    switch (this.form.get('fasciaHeight').value) {
      case 'Other (direct value input)': {
        this.showCustomFasciaHeight = true;
        break;
      }
      default: {
        this.showCustomFasciaHeight = false;
        this.form.get('customFasciaHeight').setValue('');
      }
    }
    this.activateNextButtonByFillRequireFormFields();
  }

  selectFasciaThickness() {
    switch (this.form.get('fasciaThickness').value) {
      case 'Other (direct value input)': {
        this.showCustomFasciaThickness = true;
        break;
      }
      default: {
        this.showCustomFasciaThickness = false;
        this.form.get('customFasciaThickness').setValue('');
      }
    }
    this.activateNextButtonByFillRequireFormFields();
  }

  selectProjectLocation() {
    switch (this.form.get('projectLocation').value) {
      case 'Outdoor': {
        this.showTypeOutdoorLocation = true;
        this.form.get('projectTypeOutdoorLocation').setValue('');
        break;
      }
      case 'Indoor': {
        this.showTypeOutdoorLocation = false;
        this.showDistanceFromWaterLocation = false;
        this.form.get('projectTypeOutdoorLocation').setValue('');
        this.form.get('projectDistanceFromWaterLocation').setValue(0);
        break;
      }
    }
    this.activateNextButtonByFillRequireFormFields();
  }

  selectProjectTypeOutdoorLocation() {
    switch (this.form.get('projectTypeOutdoorLocation').value) {
      case 'Coastal (Salt water)': {
        this.showDistanceFromWaterLocation = true;
        break;
      }
      case 'Inland': {
        this.showDistanceFromWaterLocation = false;
        this.form.get('projectDistanceFromWaterLocation').setValue(0);
        break;
      }
    }
  }

  changeDistanceFromWaterLocation(event) {
    switch (event) {
      case 'increase': {
        this.form.get('projectDistanceFromWaterLocation').setValue(+(this.form.get('projectDistanceFromWaterLocation').value) + 1);
        break;
      }
      case 'decrease': {
        if (this.form.get('projectDistanceFromWaterLocation').value > 0) {
          this.form.get('projectDistanceFromWaterLocation').setValue(+(this.form.get('projectDistanceFromWaterLocation').value) - 1);
        }
        break;
      }
      default: {
        if (this.form.get('projectDistanceFromWaterLocation').value < 0) {
          this.form.get('projectDistanceFromWaterLocation').setValue(+(this.form.get('projectDistanceFromWaterLocation').value) * -1);
        }
      }
    }
  }

  selectDealer(id) {
    this.dealer = this.dealersData.dealers.find(d => d.id === id);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getNeedsPoints() {
    const railingComponents = this.railingGenerationService.getRailingComponent();
    const cornerPost = this.productSrvc.getCurrentCornerPost();
    const stage = this.stageService;
    const currentParams = this.dataMenuItems.getCurrentParams();
    // this.helperLinesService.removeTestMarkers();
    // let Posts = [];
    // let infills = [];
    let dHeight;
    let intermediatePoints;
    let terminationPostsPositions;
    let cornerPoints;
    let rotations;

    const floors = stage.getCompoundFloor();

    const floorsPosts = [];

    const floorsCornerPosts = [];

    for (let i = 0; i < floors.children.length; i++) {
      const floor = floors.children[i];

      dHeight = floor.getWorldPosition(new THREE.Vector3()).y;

      const projectType = this.projectManagerService.getProjectType();
      let maxWidth =
        projectType === 'business'
          ? this.sizeHelper.INCHToCM(60)
          : this.sizeHelper.INCHToCM(72);

      if (
        currentParams.infill === 'glass' ||
        (currentParams.infill === 'horizontalCable' &&
          currentParams.railingHeight === '42')
      ) {
        maxWidth = this.sizeHelper.INCHToCM(60);
      }

      if (
        currentParams.railingType === 'Steel flat bar' ||
        currentParams.railingType === 'Steel round tubular'
      ) {
        maxWidth = this.sizeHelper.INCHToCM(36);
      }

      if (currentParams.railingType === 'Modern') {
        // same rule as the 3D build — both read it from modern.config
        maxWidth = this.sizeHelper.INCHToCM(modernSpanInches(currentParams.sectionSpan));
      }

      const intAndTermPoints = this.railingCalculationHelperService.getPositionsForIntermediatePosts(
        floor,
        maxWidth,
        railingComponents.intermediatePost,
        railingComponents.cornerPost,
        railingComponents.cornerPost45degree,
        railingComponents.cornerPost135degree
      );
      intermediatePoints = intAndTermPoints.intermediatePoints;
      terminationPostsPositions = intAndTermPoints.terminationPostsPositions;

      floorsPosts.push(intermediatePoints);

      const cornerPosAndRot = this.railingCalculationHelperService.getPositionsForCornerPosts(
        floor,
        railingComponents.cornerPost,
        railingComponents.insideCornerPost,
        railingComponents.intermediatePost,
        railingComponents.cornerPost45degree,
        railingComponents.cornerPost135degree
      );
      cornerPoints = cornerPosAndRot.cornerPoints;
      rotations = cornerPosAndRot.rotations;

      const floorCornerPosts = cornerPoints.map((post, index) => ({
        ...post,
        rotation:
          cornerPost.mountType === 'Fascia Bracket Mount'
            ? rotations[index] + Math.PI / 2
            : rotations[index],
        visible: post.notCorner ? !post.notCorner : true
      }));

      floorsCornerPosts.push(floorCornerPosts);
    }

    const params = {
      intermediatePoints,
      terminationPostsPositions,
      cornerPoints,
      rotations,
      floorsCornerPosts
    };

    // console.log('params', params);
    return params;
  }

  private _createSprite(spriteData) {
    let sideLength = this.sizeHelper.CMToFTAndINCHToEdge(spriteData.length);
    sideLength = sideLength.replace('\'', '\' ');

    // const spriteMap = this._loader.load('../../assets/images/sprites/size_grip.png');
    const fp = new THREE.Vector3(spriteData.firstPoint.x, 0, spriteData.firstPoint.y);
    const sp = new THREE.Vector3(spriteData.secondPoint.x, 0, spriteData.secondPoint.y);
    const fpOnScreen = this.sceneUtils.worldToScreen(fp.clone());
    const spOnScreen = this.sceneUtils.worldToScreen(sp.clone());
    const diff = new THREE.Vector3(spOnScreen.x - fpOnScreen.x, 0, fpOnScreen.y - spOnScreen.y);
    const angle = Math.atan2(diff.z, diff.x);

    // const spriteMaterial = new THREE.SpriteMaterial({
    //   map: spriteMap,
    //   color: 0xffffff,
    //   depthTest: false,
    //   depthWrite: false,
    //   rotation: angle
    // });

    const sprite = this.imageUtilsService.textSpriteForPdfSnapShot(sideLength,
      { fontsize: 16,
        borderColor: { r: 255, g: 0, b: 0, a: 0.5 },
        backgroundColor: { r: 255, g: 100, b: 100, a: 0.1 } });

    const delta = sp.clone().sub(fp);
    const length = delta.length();
    const direction = delta.normalize();
    const middle = fp.add(direction.multiplyScalar(length / 2));

    // const sprite = new AutoScaleSprite(30, 30, spriteMaterial);

    sprite.position.set(middle.x, 0, middle.z);

    return sprite;
  }

  private _calculateSpriteData(points, edges) {
    const result = [];
    const up = new THREE.Vector3(0, 1, 0);

    for (let i = 0; i < points.length; i++) {
      const firstPoint = points[i];
      const secondPoint = points[(i + 1) % points.length];
      const length = edges[i].length;

      if (!firstPoint.superstructureType) {
        const diff = new THREE.Vector3(
          secondPoint.x - firstPoint.x,
          0,
          secondPoint.y - firstPoint.y
        );
        const angle = -Math.atan2(diff.z, diff.x);
        const ppPoint = points[i - 1] || points[points.length - 1];
        const nnPoint = points[(i + 2) % points.length];
        const pPoint = firstPoint;
        const nPoint = secondPoint;
        const vector1 = new THREE.Vector3(pPoint.x - ppPoint.x, 0, pPoint.y - ppPoint.y);
        const vector2 = new THREE.Vector3(nPoint.x - nnPoint.x, 0, nPoint.y - nnPoint.y);

        let firstAngle = -Math.atan2(vector1.z, vector1.x);
        let secondAngle = -Math.atan2(vector2.z, vector2.x) - Math.PI;
        firstAngle = Math.abs(angle - firstAngle);
        secondAngle -= angle;
        secondAngle = Math.abs(secondAngle);

        result.push({
          firstPoint,
          secondPoint,
          length,
          angles: [firstAngle, secondAngle],
          vectors: [vector1, vector2, diff],
          number: i,
          normal: diff
            .clone()
            .applyAxisAngle(up, Math.PI / 2)
            .normalize()
        });
      }
    }
    return result;
  }

  createEdgesForStairs(newObject, points) {
    const edges = [];
    for (let i = 0; i < newObject.userData.points.length; i++) {
      const firstPoint = points[i];
      const secondPoint = points[(i + 1) % points.length];
      const length = Math.sqrt(
        Math.pow(points[i].x - points[(i + 1) % points.length].x, 2) +
        Math.pow(points[i].y - points[(i + 1) % points.length].y, 2)
      );
      if (i === newObject.userData.points.length - 1) {
        firstPoint.superstructureType = true;
      }
      edges.push({firstPoint, secondPoint, length});
    }
    return edges;
  }

  addTierStepsPointsToFloor(object, spritesData) {
    const tierSteps = object.getObjectByName('tierSteps');
    // console.log('tierSteps', tierSteps);
    // console.log('floor spritesData', spritesData);
    if (tierSteps) {
      const newSpriteData = [...spritesData];
      const config = tierSteps.userData.config;
      const tierStepsFirstPoint = config.firstPoint;
      const tierStepsSecondPoint = config.secondPoint;
      const tierPoints = this.getTierPoints({
        firstPoint: tierStepsFirstPoint,
        secondPoint: tierStepsSecondPoint
      }, config);
      // console.log('tierPoints', tierPoints);
      const tierStepsSpritesData = [{
        firstPoint: tierPoints[0],
        secondPoint: tierPoints[1],
        length: tierPoints[0].length
      }, {firstPoint: tierPoints[2], secondPoint: tierPoints[3], length: tierPoints[2].length}];
      // console.log('tierStepsSpritesData', tierStepsSpritesData);
      // console.log('newSpriteData', newSpriteData);
      newSpriteData.forEach(el => {
        tierStepsSpritesData.forEach(el2 => {
          if (el.firstPoint.x === el2.firstPoint.x && el.firstPoint.y === el2.firstPoint.y) {
            el.firstPoint.x = el2.secondPoint.x;
            el.firstPoint.y = el2.secondPoint.y;
            el.length = el.length + el2.length;
          } else if (el.secondPoint.x === el2.secondPoint.x && el.secondPoint.y === el2.secondPoint.y) {
            el.secondPoint.x = el2.firstPoint.x;
            el.secondPoint.y = el2.firstPoint.y;
            el.length = el.length + el2.length;
          }
        });
      });
      // console.log('update newSpriteData', newSpriteData);
      return newSpriteData;
    }
    return null;
  }

  getPointForStairs(stairs) {
    const {firstPoint, secondPoint, width, height} = stairs.userData.config;
    const start = new THREE.Vector3(firstPoint.x, 0, firstPoint.y);
    const end = new THREE.Vector3(secondPoint.x, 0, secondPoint.y);
    const direction = new THREE.Vector3().subVectors(end, start).normalize();
    const edgeNormal = new THREE.Vector3()
      .subVectors(end, start)
      .applyAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI / 2)
      .normalize();

    const topStair = stairs.getObjectByName('Top');
    const bottomStair = stairs.getObjectByName('Bottom');
    const dof = new THREE.Vector3().subVectors(start, topStair.position).projectOnVector(edgeNormal);
    const leftStairPoint = topStair.position.clone().add(direction.clone().negate().multiplyScalar(width / 2)).add(dof);
    const rightStairPoint = topStair.position.clone().add(direction.multiplyScalar(width / 2)).add(dof);
    start.y = end.y = leftStairPoint.y = rightStairPoint.y = height;
    start.y -= 10;
    end.y -= 10;
    leftStairPoint.y -= 10;
    rightStairPoint.y -= 10;

    const stairDimensionOffset = new THREE.Vector3().subVectors(bottomStair.position, topStair.position);
    return {start, leftStairPoint, end, rightStairPoint, stairDimensionOffset};
  }

  setCenterPosition() {
    const scene = this.stageService.getScene();
    const params = {
      min: { x: 0, y: 0, z: 0 },
      max: { x: 0, y: 0, z: 0 },
    };
    scene.traverse(el => {
      if (el.type === 'Object3D') {
        const newBox = new THREE.Box3().setFromObject(el);
        if (newBox.max.x > params.max.x) params.max.x = newBox.max.x;
        if (newBox.max.y > params.max.y) params.max.y = newBox.max.y;
        if (newBox.max.z > params.max.z) params.max.z = newBox.max.z;
        if (newBox.min.x < params.min.x) params.min.x = newBox.min.x;
        if (newBox.min.y < params.min.y) params.min.y = newBox.min.y;
        if (newBox.min.z < params.min.z) params.min.z = newBox.min.z;
      }
    });
    return params
  }

  defaultZoomByHeight(canvasHeight) {
    let zoom;
      if (canvasHeight <= 700) {
        zoom = 8;
      } else if (canvasHeight <= 800) {
        zoom = 7;
      } else if (canvasHeight <= 900) {
        zoom = 6;
      } else if (canvasHeight <= 1000) {
        zoom = 5.5;
      }  else if (canvasHeight <= 1100) {
        zoom = 5;
      } else if (canvasHeight <= 1200) {
        zoom = 4.5;
      } else if (canvasHeight <= 1300) {
        zoom = 4;
      } else if (canvasHeight <= 1600) {
        zoom = 3.5;
      } else if (canvasHeight <= 1900) {
        zoom = 3;
      } else {
        zoom = 2;
      }
    return zoom;
  }

  getZoomforSnapshot(scene) {
    const floor = scene.getObjectByName('compoundFloor');
    const oldFloorPosition = floor.position;
    const floorParams = new THREE.Box3().setFromObject(floor);
    // console.log('camera position', this.cameraService.camera.position);
    const worldPosition = new THREE.Vector3();
    // const someWorldPosition = floor.getWorldPosition( worldPosition );
    // console.log('someWorldPosition', someWorldPosition);
    const currentZoom = this.zoomSrvc.getCurrentZoom();
    const canvas = document.querySelector('canvas');
    const canvasHeight = canvas.clientHeight;
    const canvasWeight = canvas.clientWidth;
    const x = floorParams.max.x - floorParams.min.x;
    const z = floorParams.max.z - floorParams.min.z;
    const xCameraPosition = (floorParams.max.x + floorParams.min.x) / 2;
    const zCameraPosition = (floorParams.max.z + floorParams.min.z) / 2;
    const objWidth = x >= z ? x : z;
    const canvasWidth = canvasWeight <= canvasHeight ? canvasWeight : canvasHeight;
    // console.log('currentZoom', currentZoom);
    // let newZoom = (objWidth * currentZoom) / canvasWidth * 1.2;
    // let newZoom = (objWidth * currentZoom) / 450;
    let newZoom = (objWidth * this.defaultZoomByHeight(canvasHeight)) / 450;
    if (newZoom > 20) {
      newZoom = 20;
    }
    if (newZoom < 1) {
      newZoom = 1;
    }
    this.cameraService.camera.position.set(xCameraPosition, newZoom, zCameraPosition);
    return newZoom;
  }

  getSnapshotForPdf() {
    this.topToolbarService.switchTo2D(true);
    // console.log(document.querySelector('canvas'));
    const stage = this.stageService;
    const scene = this.stageService.getScene();
    // let floor = scene.getObjectByName('compoundFloor');
    // let floorParams = new THREE.Box3().setFromObject(floor);
    // const params = new THREE.Box3().setFromObject(scene);
    // const params2 = this.setCenterPosition();
    // console.log('position', (params.max.x + params.min.x) / 2, (params.max.y + params.min.y) / 2, scene.position.z);
    // scene.position.set((params.max.x + params.min.x) / 2, (params.max.y + params.min.y) / 2, scene.position.z);
    // console.log('params scene', params);
    // console.log('params2 scene', params2);
    // console.log('params floor', floorParams);
    // console.log('zoom scene', this.zoomSrvc.getCurrentZoom());
    this.cameraService.reset();
    // const oldSize = this.rendererService.get().getSize();
    // this.rendererService.resize(1200, 700);
    // this.rendererService.render(scene);
    // this.rendererService.resize(oldSize.width, oldSize.height);
    this.zoomSrvc.set(this.getZoomforSnapshot(scene));
    // this.zoomSrvc.set(20);
    // console.log('zoom scene update', this.zoomSrvc.getCurrentZoom());
    // let points = [];
    // let edges = [];
    let object;

    /*const params = this.getNeedsPoints();
    this.drawDimensionsForPoints(params.floorsCornerPosts);
    this.drawDimensionsForPoints(params.intermediatePoints);
    this.drawDimensionsForPoints(params.terminationPostsPositions);
    this.drawDimensionsForPoints(params.cornerPoints);*/
    this.deleteDimensions('autoScaleSprite');
    scene.traverse(obj => {
      if (obj.visible && obj.name.toLowerCase() === 'floor') {
        // console.log('getSnapshotForPdf obj', obj);
        object = obj;
        // this.imageUtilsService.drawTextSpritesForPdfSnapShot(object);
        const floorHeight = object.getWorldPosition(new THREE.Vector3()).y;
        let spritesData = this._calculateSpriteData(object.userData.points, object.userData.edges);
        const updateSpritesData = this.addTierStepsPointsToFloor(object, spritesData);
        if (updateSpritesData) {
          spritesData = [...updateSpritesData];
        }
        // console.log('floor spritesData', spritesData);
        // console.log('floor object.userData.points', object.userData.points);
        spritesData.forEach(spriteData => {
          const sprite = this._createSprite(spriteData);
          sprite.userData.data = spriteData;
          sprite.position.y = floorHeight;
          sprite.name = 'dimensionForSnapshot';
          this.drawDimensionsBySpritesData(spriteData);
          // this._sprites.push(sprite);
          stage.add(sprite);
        });

        // this.drawDimensionsBySpritesData(spritesData);
        // this.drawDimensions(obj);

        // const objectPoints = object.userData.points;
        // console.log('objectPoints', objectPoints);
        // const objectEdges = object.userData.edges;
      }
    });

    scene.traverse(obj => {
      if (obj.visible && obj.name.toLowerCase() === 'stairs') {
        const newObject = obj;
        const stairsPoints = this.getPointForStairs(newObject);
        const floor = stage.getFloorById(newObject.userData.config.floorId);
        // console.log('getFloorById', floor);
        // const objectParams = new THREE.Box3().setFromObject(newObject);
        // console.log('objectParams', objectParams);
        const points1 = newObject.userData.config;
        const points2 = newObject.userData;
        // newObject.userData.points = [{x: points1.firstPoint.x, y: points1.firstPoint.y}, {x: points2.firstOutPoint.x, y: points2.firstOutPoint.z}, {x: points2.secondOutPoint.x, y: points2.secondOutPoint.z}, {x: points1.secondPoint.x, y: points1.secondPoint.y}];
        newObject.userData.points = [
          {x: stairsPoints.start.x, y: stairsPoints.start.z},
          {x: stairsPoints.leftStairPoint.x, y: stairsPoints.leftStairPoint.z},
          {x: points2.firstOutPoint.x, y: points2.firstOutPoint.z},
          {x: points2.secondOutPoint.x, y: points2.secondOutPoint.z},
          {x: stairsPoints.rightStairPoint.x, y: stairsPoints.rightStairPoint.z},
          {x: stairsPoints.end.x, y: stairsPoints.end.z}
        ];
        const points = newObject.userData.points;
        const edges = this.createEdgesForStairs(newObject, points);
        const floorHeight = newObject.getWorldPosition(new THREE.Vector3()).y;
        const spritesData = this._calculateSpriteData(points, edges);
        spritesData.forEach(spriteData => {
          const sprite = this._createSprite(spriteData);
          sprite.userData.data = spriteData;
          sprite.position.y = floorHeight;
          sprite.name = 'dimensionForSnapshot';
          this.drawDimensionsBySpritesData(spriteData);
          // this._sprites.push(sprite);
          stage.add(sprite);
        });
        // newObject.userData.points = [newObject.userData.config.firstPoint, newObject.userData.config.prevPoint, newObject.userData.config.nextPoint, newObject.userData.config.secondPoint];
        // this.drawDimensions(newObject);
      }
    });

    // object.userData.points = points;
    // this.drawDimensions(object);
    // object.userData.edges = edges;
    // console.log('objects', object);
    // this.select3dService.setSelectedTier(object);

    setTimeout(() => {
      this.screenShot = this.rendererService.getScreenShot();
      // this.screenShot = this.snapShotSrvc.getSnapshots()[0];
      // console.log('screenShot', this.screenShot);
      this.resetScreenShotParams();
    }, 1);
  }

  resetScreenShotParams() {
    this.cameraService.reset();
    this.topToolbarService.switchTo2D(false);
    this.zoomSrvc.reset();
    setTimeout(() => {
      this.deleteDimensions('floorDimensionForSnapshot');
      this.deleteDimensions('dimensionForSnapshot');
    }, 3000);
  }

  drawDimensionsForPointsXY(points) {
    if (points.length) {
      if (Array.isArray(points[0])) {
        points.forEach(arr => {
          const pts = arr.map(p => {
            return new THREE.Vector3(p.x, 0, p.y);
          });
          const floorHull = new FloorHull(pts);
          // floorHull.position.y = floorHeight;
          floorHull.name = 'floorDimensionForSnapshot';
          this.stageService.add(floorHull);
        });
      } else {
        const pts = points.map(p => {
          return new THREE.Vector3(p.x, 0, p.y);
        });

        const floorHull = new FloorHull(pts);
        // floorHull.position.y = floorHeight;
        floorHull.name = 'floorDimensionForSnapshot';
        this.stageService.add(floorHull);
      }
    }
  }

  drawDimensionsForPoints(points) {
    if (points.length) {
      if (Array.isArray(points[0])) {
        points.forEach(arr => {
          const pts = arr.map(p => {
            return new THREE.Vector3(p.x, 0, p.z);
          });
          const floorHull = new FloorHull(pts);
          // floorHull.position.y = floorHeight;
          floorHull.name = 'floorDimensionForSnapshot';
          this.stageService.add(floorHull);
        });
      } else {
        const pts = points.map(p => {
          return new THREE.Vector3(p.x, 0, p.z);
        });

        const floorHull = new FloorHull(pts);
        // floorHull.position.y = floorHeight;
        floorHull.name = 'floorDimensionForSnapshot';
        this.stageService.add(floorHull);
      }
    }
  }

  drawDimensions(floor) {
    const points = floor.userData.points;
    const floorHeight = floor.getWorldPosition(new THREE.Vector3()).y;
    // const spritesData = this._calculateSpriteData(points);
    // spritesData.forEach(spriteData => {
    //   const sprite = this._createSprite(spriteData);
    //   sprite.userData.data = spriteData;
    //   sprite.position.y = floorHeight;
    //   this._sprites.push(sprite);
    //   this.stage.add(sprite);
    // });
    if (points) {
      const pts = points.map(p => {
        if (floor.name === 'floor') {
          return new THREE.Vector3(p.x, 0, p.y);
        }
        if (floor.name === 'stairs') {
          return new THREE.Vector3(p.x, 0, p.y);
        }
      });
      const floorHull = new FloorHull(pts);
      floorHull.position.y = floorHeight;
      floorHull.name = 'floorDimensionForSnapshot';
      this.stageService.add(floorHull);
    }
  }

  drawDimensionsBySpritesData(data) {
    const pts = [];
    if (data) {
        pts.push(new THREE.Vector3(data.firstPoint.x, 0, data.firstPoint.y));
        pts.push(new THREE.Vector3(data.secondPoint.x, 0, data.secondPoint.y));
      // data.forEach(p => {
      //   pts.push(new THREE.Vector3(p.firstPoint.x, 0, p.firstPoint.y));
      //   pts.push(new THREE.Vector3(p.secondPoint.x, 0, p.secondPoint.y));
      // });
      const floorHull = new FloorHull(pts);
      // floorHull.position.y = floorHeight;
      floorHull.name = 'floorDimensionForSnapshot';
      this.stageService.add(floorHull);
    }
  }

  deleteDimensions(name) {
    const stage = this.stageService;
    const scene = this.stageService.getScene();
    let floorDimensionForSnapshotArr = [];
    scene.traverse(obj => {
      if (obj.visible && obj.name === name) {
        floorDimensionForSnapshotArr = [...floorDimensionForSnapshotArr, obj];
      }
    });
    floorDimensionForSnapshotArr.forEach(obj => stage.remove(obj));
  }

  prepareStairParams (points, tierType, floor) {
    const count = points.length;
    const tierConfig = this.constants.tierTypeSettingsMap[tierType];
    const currentTierheight = floor.getWorldPosition(new THREE.Vector3()).y + 5;
    for (let i = 0; i < points.length; i++) {
      if (!points[i].superstructureType) {
        // const spriteMap = this.loader.load(spriteUrl);
        //
        // const spriteMaterial = new THREE.SpriteMaterial({ map: spriteMap, color: 0xffffff, depthTest: false, depthWrite: false });
        //
        // const sprite = new AutoScaleSprite(50, 50, spriteMaterial);

        const edge = {
          firstPoint: points[i],
          secondPoint: points[(i + 1) % count],
          length: Math.sqrt(
            Math.pow((points[i].x - points[(i + 1) % count].x), 2) +
            Math.pow((points[i].y - points[(i + 1) % count].y), 2)
          )
        };

        const config = {
          height: 0,
          // height: currentTierheight - 5 + tierConfig.tierHeightShift,
          edge: edge,
          // floorId: sprite.userData.floorId,
          // superstructureType: sprite.userData.superstructureType,
          distanceToTier: tierConfig.distanceToTier
        };

        // sprite.userData.edge = edge;
        // sprite.userData.height = currentTierheight - 5 + tierConfig.tierHeightShift;
        // sprite.userData.floorId = floor.id;
        // sprite.userData.superstructureType = tierType;
        // sprite.userData.distanceToTier = tierConfig.distanceToTier;

        // this.sprites.push(sprite);
        // sprite.position.set(
        //   (points[i].x + points[(i + 1) % points.length].x) / 2,
        //   currentTierheight,
        //   (points[i].y + points[(i + 1) % points.length].y) / 2
        // );
        // this.stage.add(sprite);
      }
    }
  }

  getTierPoints(edge, config): Array<any> {
    console.log('config', config);
    const A = new THREE.Vector3(edge.firstPoint.x, 0, edge.firstPoint.y);
    const B = new THREE.Vector3(edge.secondPoint.x, 0, edge.secondPoint.y);

    const AB = new THREE.Vector3(B.x - A.x, 0, B.z - A.z);
    const vect = new THREE.Vector3(AB.z, 0, -AB.x);
    const norm = vect.normalize();
    const distanceToTier = this.constants.tierTypeSettingsMap[config.superstructureType].distanceToTier;
    // const distanceToTier = config.distanceToTier || config.distance;
    const nearPointsDistance = norm.clone().setLength(distanceToTier),
      // farPointsDistance = norm.clone().setLength(182.4); // to do make value descriptive
      farPointsDistance = norm.clone().setLength(0); // to do make value descriptive

    const firstNearPoint = A.clone().add(nearPointsDistance),
      firstFarPoint = A.clone().add(farPointsDistance),
      secondFarPoint = B.clone().add(farPointsDistance),
      secondNearPoint = B.clone().add(nearPointsDistance),
      width = AB.length() - this.constants.minimalSpaceForStairsOnSIde*2;

    const points = [
      {
        x: firstNearPoint.x,
        y: firstNearPoint.z,
        length: distanceToTier
      },
      {
        x: firstFarPoint.x,
        y: firstFarPoint.z,
        length: distanceToTier
      },
      {
        x: secondFarPoint.x,
        y: secondFarPoint.z,
        length: distanceToTier
      },
      {
        x: secondNearPoint.x,
        y: secondNearPoint.z,
        length: distanceToTier,
        superstructureType: config.superstructureType,
        width: width,
        distance: AB.length() / 2,
        parent: true // to do rename property
      },
    ]

    return points;
  }

  getNearTierPoints(edge, config): Array<any> {
    const A = new THREE.Vector3(edge.firstPoint.x, 0, edge.firstPoint.y);
    const B = new THREE.Vector3(edge.secondPoint.x, 0, edge.secondPoint.y);

    const AB = new THREE.Vector3(B.x - A.x, 0, B.z - A.z);
    const vect = new THREE.Vector3(AB.z, 0, -AB.x);
    const norm = vect.normalize();
    const distanceToTier = this.constants.tierTypeSettingsMap[config.superstructureType].distanceToTier;
    const nearPointsDistance = norm.clone().setLength(distanceToTier);

    const firstNearPoint = A.clone().add(nearPointsDistance);
    const secondNearPoint = B.clone().add(nearPointsDistance);
    const width = AB.length() - this.constants.minimalSpaceForStairsOnSIde*2;

    const points = [
      {
        x: firstNearPoint.x,
        y: firstNearPoint.z,
        length: distanceToTier
      },
      {
        x: secondNearPoint.x,
        y: secondNearPoint.z,
        length: distanceToTier,
        superstructureType: config.superstructureType,
        width: width,
        distance: AB.length() / 2,
        parent: true // to do rename property
      },
    ]

    return points;
  }

  async onSubmitWithGetDealers() {
    // let currentChoices = this.dataMenuItems.getCurrentParams();
    // console.log('snapshot', this.screenShot);
    this.getSnapshotForPdf();
    let user = this.authService.getUser();
    user = {
      ...user,
      ...{
        firstName: this.form.get('firstName').value,
        lastName: this.form.get('lastName').value,
        companyName: this.form.get('company').value,
        phone: this.form.get('phone').value,
        email: this.form.get('email').value,
        zipCode: this._formatZipCode(this.form.get('zipCode').value)
      }
    };
    if (this.isInterior) {
      this._getCurrentPosition()
        .pipe(
          switchMap((res: any) => {
            return combineLatest(
              this.authService.updateUser(user),
              this.getQuoteResourceService.getDealers({
                zipCode: this.form.get('projectZip').value,
                coords: res
              })
            ).pipe(
              map(([userUpdateRes, getDealersRes]) => {
                // console.log('getDealersRes', getDealersRes);
                this.authService.setUser(userUpdateRes);
                // this.dealersData = getDealersRes.dealers;
                this.dealersData = {
                  getAddress: this.getAddress.bind(this),
                  dealers: getDealersRes.dealers,
                  comments: this.form.get('comments').value,
                  projectUrl: `${environment.appUrl}/browsing/${this.projectManagerService.project.id}`,
                  zipCode: this.form.get('zipCode').value,
                  coords: getDealersRes.coords || this.coords
                };
                // clear dealers array in form
                if (this.form.get('dealers').value.length) {
                  this.form.get('dealers').value.forEach((el) => {
                    (<FormArray>this.form.get('dealers')).removeAt(0);
                  });
                }
                for (let i = 0; i < this.dealersData.dealers.length; i++) {
                  (<FormArray>this.form.get('dealers')).push(
                    this.fb.group({
                      id: [this.dealersData.dealers[i].id],
                      companyName: [this.dealersData.dealers[i].values.companyname],
                      addressAddress1: [this.dealersData.getAddress(this.dealersData.dealers[i].values, 'address1')],
                      addressCity: [this.dealersData.getAddress(this.dealersData.dealers[i].values, 'city')],
                      addressState: [this.dealersData.getAddress(this.dealersData.dealers[i].values, 'state')[0]['text']],
                      addressZipcode: [this.dealersData.getAddress(this.dealersData.dealers[i].values, 'zipcode')],
                      url: [this.dealersData.dealers[i].values['url']],
                      phone: [this.dealersData.dealers[i].values['phone']],
                      distance: [this.dealersData.dealers[i].values['formulanumeric']],
                      mapSearchUrl: this.dealersData.dealers[i].mapSearchUrl
                    })
                  );
                }
                this.isGetDealerData = false;
                this.activateNextButtonByFillRequireFormFields();
                console.log('this.dealersData', this.dealersData);
                // this.dialogRef.close({
                //   zipCode: this.form.get('zipCode').value,
                //   comments: this.form.get('comments').value,
                //   dealers: getDealersRes.dealers
                // });
              })
            );
          })
        )
        .subscribe();
    } else {
      this._getCurrentPosition()
        .pipe(
          switchMap((res: any) => {
            return combineLatest(
              this.authService.updateUser(user),
              this.projectSaveService.save(this.form.get('projectName').value, false),
              this.getQuoteResourceService.getDealers({
                zipCode: this.form.get('projectZip').value,
                coords: res
              })
            ).pipe(
              map(([userUpdateRes, projectUpdateRes, getDealersRes]) => {
                // console.log('getDealersRes', getDealersRes);
                this.authService.setUser(userUpdateRes);
                // this.dealersData = getDealersRes.dealers;
                this.dealersData = {
                  getAddress: this.getAddress.bind(this),
                  dealers: getDealersRes.dealers,
                  comments: this.form.get('comments').value,
                  projectUrl: `${environment.appUrl}/browsing/${this.projectManagerService.project.id}`,
                  zipCode: this.form.get('zipCode').value,
                  coords: getDealersRes.coords || this.coords
                };
                // clear dealers array in form
                if (this.form.get('dealers').value.length) {
                  this.form.get('dealers').value.forEach((el) => {
                    (<FormArray>this.form.get('dealers')).removeAt(0);
                  });
                }
                for (let i = 0; i < this.dealersData.dealers.length; i++) {
                  (<FormArray>this.form.get('dealers')).push(
                    this.fb.group({
                      id: [this.dealersData.dealers[i].id],
                      companyName: [this.dealersData.dealers[i].values.companyname],
                      addressAddress1: [this.dealersData.getAddress(this.dealersData.dealers[i].values, 'address1')],
                      addressCity: [this.dealersData.getAddress(this.dealersData.dealers[i].values, 'city')],
                      addressState: [this.dealersData.getAddress(this.dealersData.dealers[i].values, 'state')[0]['text']],
                      addressZipcode: [this.dealersData.getAddress(this.dealersData.dealers[i].values, 'zipcode')],
                      url: [this.dealersData.dealers[i].values['url']],
                      phone: [this.dealersData.dealers[i].values['phone']],
                      distance: [this.dealersData.dealers[i].values['formulanumeric']],
                      mapSearchUrl: this.dealersData.dealers[i].mapSearchUrl
                    })
                  );
                }
                this.isGetDealerData = false;
                this.activateNextButtonByFillRequireFormFields();
                console.log('this.dealersData', this.dealersData);
                // this.dialogRef.close({
                //   zipCode: this.form.get('zipCode').value,
                //   comments: this.form.get('comments').value,
                //   dealers: getDealersRes.dealers
                // });
              })
            );
          })
        )
        .subscribe();
    }
  }

  getFormData(params, pdfProject, railingType) {
    const data = new FormData();
    // console.log('railingType', railingType);
    console.log('pdfProject', pdfProject);
    if (pdfProject && railingType === 'DesignRail') {
      data.append('file', pdfProject, 'project' + Date.now() + '.pdf');
    }
    for (const [key, value] of Object.entries(params)) {
      data.append(key, value);
    }
    // console.log('data.get(pdf)', data.get('file'));
    return data;
  }

  async onSubmit() {
    this.showLoading = true;
    // const dealer = this.dealersData.dealers.find(d => d.id === this.form.get('selected').value);
    // this.topToolbarService.switchTo2D(true);
    // this.screenShot = this.rendererService.getScreenShot();
    // console.log('snapshot', this.screenShot);
    let pdfProject;
    const railingType = this.dataMenuItems.getCurrentParams().railingType;
    if (railingType === 'DesignRail') {
      pdfProject = await this.pdfService.createPdfProject(this.form.get('projectName').value);
    }
    const user = this.authService.getUser();
    console.log('this.dealer', this.dealer);
    const params = {
      dealer: this.dealer.id,
      comments: this.dealersData.comments,
      userId: user.id,
      projectUrl: this.dealersData.projectUrl,
      zipCode: this.dealersData.zipCode,
      // userParams: {
        firstName: this.form.get('firstName').value,
        lastName: this.form.get('lastName').value,
        company: this.form.get('company').value,
        phone: this.form.get('phone').value,
        email: this.form.get('email').value,
      // },
      // projectParams: {
        addressLine1: this.form.get('addressLine1').value,
        addressLine2: this.form.get('addressLine2').value,
        city: this.form.get('city').value,
        stateProvince: this.form.get('stateProvince').value,
        country: this.form.get('country').value,
        projectName: this.form.get('projectName').value,
        projectZip: this.form.get('projectZip').value,
        buyingTimeFrame: this.form.get('buyingTimeFrame').value,
        projectType: this.form.get('projectType').value,
        projectLocation: this.form.get('projectLocation').value,
        projectTypeOutdoorLocation: this.form.get('projectTypeOutdoorLocation').value,
        projectDistanceFromWaterLocation: this.form.get('projectDistanceFromWaterLocation').value,
        railingHeight: this.form.get('railingHeight').value,
        infill: this.form.get('infill').value,
        infillColor: this.form.get('infillColor').value,
        mountingOption: this.form.get('mountingOption').value,
        mountingSurface: this.form.get('mountingSurface').value,
        topRail: this.form.get('topRail').value,
        postColor: this.form.get('postColor').value,
        topRailColor: this.form.get('topRailColor').value,
        intermediatePicket: this.form.get('intermediatePicket').value,
        laserPanelColor: this.form.get('laserPanelColor').value,
        fasciaThickness: this.form.get('fasciaThickness').value,
        fasciaHeight: this.form.get('fasciaHeight').value,
        stairPostAngle: this.form.get('stairPostAngle').value,
        customFasciaHeight: this.form.get('customFasciaHeight').value,
        customFasciaThickness: this.form.get('customFasciaThickness').value,
        customAngle: this.form.get('customAngle').value,
        infillIntermediateRail: this.form.get('infillIntermediateRail').value,
        infillStSteelEndCaps: this.form.get('infillStSteelEndCaps').value,
        infillStSteelPickets: this.form.get('infillStSteelPickets').value,
        infillConcealKits: this.form.get('infillConcealKits').value,
        infillStandartCablerailKits: this.form.get('infillStandartCablerailKits').value,
        stairHandrail: this.form.get('stairHandrail').value,
        lighting: this.form.get('lighting').value,
        accessories: this.accessories,
        basePlateCovers: this.form.get('mountingOption').value === 'Base Mount' ? this.form.get('basePlateCovers').value : false
      // }
    };
    // console.log('params', params);
    const formData = this.getFormData(params, pdfProject, railingType);
    // console.log('formData', formData);
    // console.log('formData.pdf', formData);
    this.getQuoteResourceService
      .chooseDealer(formData)
      // .chooseDealer(params)
      .pipe(
        map(res => {
          // console.log('onSubmit res', res);
          this.showLoading = false;
          this.dialogRef.close({
            // dealer: res.dealer,
            dealer: this.dealer,
            zipCode: this.dealersData.zipCode,
            comments: this.dealersData.comments,
            dealers: this.dealersData.dealers,
            coords: this.dealersData.coords
          });
        }),
        catchError(err => {
          this.showLoading = false;
          return ErrorObservable.create('Error chosing dealer');
        })
      )
      .subscribe();
  }

  getAddress(data, addressPath) {
    if (data[`address.${addressPath}`]) {
      return data[`address.${addressPath}`];
    } else {
      return data[`billingaddress.${addressPath}`];
    }
  }

  getFormParams (item) {
    return this.form.get('firstName')[item];
  }

  getFormDataForPDF(pdfFile) {
    // console.log('getFormDataForPDF pdfProject', pdfFile);
    const formData = new FormData();
    formData.append('image', pdfFile);
    return formData;
    // axios.post('upload_file', formData, {
    //   headers: {
    //     'Content-Type': 'multipart/form-data'
    //   }
    // })
  }

  // getCurrentProject () {
  //   return this.projectManagerService.getCurrentProject();
  // }
  //
  // getCurrentParams () {
  //   return this.dataMenuItems.getCurrentParams();
  // }

  ngOnInit() {
    this._createForm();
    this._checkForStairs();
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-get-quote/modal-get-quote-info/modal-get-quote-info.component.ts